import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getCloudSolutionsPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/vyvoj/cloud",
		[Locale.en]: "/development/cloud",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
